import { MD } from "constants/sizes";
import { WORK_OS_IRIS_COLOR_NAME } from "styles/color-consts";
export default {
    buttonSize: MD,
    contactSalesTranslateKey: "header.contactSales",
    color: WORK_OS_IRIS_COLOR_NAME,
    outline: true,
    isWithArrow: false,
    onClick: null
};
